/**
 * Template Library
 *
 * Templates are AutoTemplate bundles fetched from storage at runtime — see
 * `services/templateService.ts`. This module keeps only the static gallery
 * configuration plus re-exports of the adapter layer.
 */

export {
  autoTemplateToTemplateDefinition,
  extractTemplateExtras,
  type TemplateExtras,
} from './templateAdapter';

/**
 * Curated featured template IDs shown on the empty canvas and create dialog.
 * Order matters — first 3 shown on empty canvas.
 */
export const FEATURED_TEMPLATE_IDS = [
  'receive-request-send-response', // HTTP trigger + response template — good for testing and demos
  'tool-call-uri-http',        // HTTP endpoint caller
] as const;

/** Connector IDs that temporarily make a published template unavailable. */
export const UNSUPPORTED_TEMPLATE_CONNECTOR_IDS = [
  '/serviceProviders/github',
  '/serviceProviders/ado-boards',
  '/serviceProviders/ado-pipelines',
] as const;
